export default {"src":"/_next/static/media/ethereum.8c566fe7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};